import { render, staticRenderFns } from "./VendorDocs.vue?vue&type=template&id=c843b208"
import script from "./VendorDocs.vue?vue&type=script&lang=js"
export * from "./VendorDocs.vue?vue&type=script&lang=js"
import style0 from "./VendorDocs.vue?vue&type=style&index=0&id=c843b208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports